import React from "react";

const DateFormat = ({ value, withTime }) => {
  let options = { year: "numeric", month: "long", day: "numeric" };
  if (withTime)
    options = {
      ...options,
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    
    let finalValue = value;
    if(typeof(value) === typeof("")){
      if(value.length < 11 && value.split("T").length === 1){
        finalValue = `${value}T00:00:00`
      }
    }
    
  const date = new Date(finalValue);

  return (
    <React.Fragment>
      {date.toLocaleDateString() !== "Invalid Date" &&
        date.toLocaleDateString("en-us", options)}
    </React.Fragment>
  );
};

export default DateFormat;
